/**
 * Created with IntelliJ IDEA.
 * User: megib
 * Date: 19/07/2017
 * Time: 4:46 PM
 * To change this template use File | Settings | File Templates.
 */


define(function (require) {
    "use strict";

    var BaseFeatureController = require("personalization-controllers/BaseFeatureController");
    var WidgetOrganizeLayout = require("personalization-web-agent-views/widget-views/widget-organize/WidgetOrganizeLayout");
    var WidgetOrganizeView = require("personalization-web-agent-views/widget-views/widget-organize/WidgetOrganizeView");

    var IFrameIntegrationWidgetOrganizeController = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        IFrameIntegrationWidgetOrganizeController = BaseFeatureController.extend({

            /************************** Marionette overriden functions *****************************************/

            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "IFrameIntegrationWidgetOrganizeController:initialize");
                this.vent = options.vent;
                this.collection = options.collection;

                this._createViews();
                this._bindEvents();
            },

            /************************** Public functions *****************************************************/

            getEditView:function(options){
                LEPersonalization.logger.info("getEditView", "IFrameIntegrationWidgetOrganizeController:getEditView");
                return this.widgetOrganizeLayout;
            },

            /************************** private functions *****************************************************/

            _createViews: function () {
                LEPersonalization.logger.info("creating views", "IFrameIntegrationWidgetOrganizeController:_createViews");
                this.widgetOrganizeLayout = new WidgetOrganizeLayout();

                this.widgetOrganizeView = new WidgetOrganizeView({
                    vent: this.vent,
                    model: this.editedModel,
                    addCustomFields: this.addCustomFields,
                    collection: this.collection
                });
            },

            _bindEvents:function(){
                this.listenTo(this.widgetOrganizeLayout, "render", this._onWidgetOrganizeLayoutRender);
                this.listenTo(this.vent, "widget-organize:cancel", this._onWidgetOrganizeCancel);
                this.listenTo(this.vent, "widget-organize:done", this._onWidgetOrganizeDone);

                this.listenTo(this.vent, "widget-organize:change:order:movetop", this._changeWidgetOrderMoveTop);
                this.listenTo(this.vent, "widget-organize:change:order:moveup", this._changeWidgetOrderMoveUp);
                this.listenTo(this.vent, "widget-organize:change:order:movedown", this._changeWidgetOrderMoveDown);
                this.listenTo(this.vent, "widget-organize:change:order:movebottom", this._changeWidgetOrderMoveBottom);
            },

            _onWidgetOrganizeLayoutRender: function() {
                this.widgetOrganizeLayout.widgetOrganizeRegion.show(this.widgetOrganizeView);
            },

            _onWidgetOrganizeCancel: function(){
                this._onWidgetOrganizeClosed();
            },

            _onWidgetOrganizeClosed: function(){
                LEPersonalization.navigateToPageMenu();
            },

            _onWidgetOrganizeDone: function() {
                this._onWidgetOrganizeClosed();
            },
            /**
             * Triggered by click on any "move-up" button
             * @param itemView
             * @param itemModel
             */
            _changeWidgetOrderMoveUp: function(itemView, itemModel) {
                LEPersonalization.logger.info("move up widget", "IFrameIntegrationWidgetOrganizeController:_changeWidgetOrderMoveUp");

                LEPersonalization.loader.setLoader();
                this.collection.moveUp(itemModel.id, {
                    reset: true,
                    success: _.bind(this._widgetReOrderSuccess,this),
                    error: _.bind(this._widgetReOrderError,this)
                });
            },

            /**
             * Triggered by click on any "move-top" button
             * @param itemView
             * @param itemModel
             */
            _changeWidgetOrderMoveTop: function(itemView, itemModel) {
                LEPersonalization.logger.info("move top widget", "IFrameIntegrationWidgetOrganizeController:_changeWidgetOrderMoveTop");

                LEPersonalization.loader.setLoader();
                this.collection.moveTop(itemModel.id, {
                    reset: true,
                    success: _.bind(this._widgetReOrderSuccess,this),
                    error: _.bind(this._widgetReOrderError,this)
                });
            },

            /**
             * Triggered by click on any "move-down" button
             * @param itemView
             * @param itemModel
             */
            _changeWidgetOrderMoveDown: function(itemView, itemModel) {
                LEPersonalization.logger.info("move down widget", "IFrameIntegrationWidgetOrganizeController:_changeWidgetOrderMoveDown");

                LEPersonalization.loader.setLoader();
                this.collection.moveDown(itemModel.id, {
                    reset: true,
                    success: _.bind(this._widgetReOrderSuccess,this),
                    error: _.bind(this._widgetReOrderError,this)
                });
            },

            /**
             * Triggered by click on any "move-bottom" button
             * @param itemView
             * @param itemModel
             */
            _changeWidgetOrderMoveBottom: function(itemView, itemModel){
                LEPersonalization.logger.info("move bottom widget", "IFrameIntegrationWidgetOrganizeController:_changeWidgetOrderMoveBottom");
                LEPersonalization.loader.setLoader();
                this.collection.moveBottom(itemModel.id, {
                    reset: true,
                    success: _.bind(this._widgetReOrderSuccess,this),
                    error: _.bind(this._widgetReOrderError,this)
                });
            },

            _widgetReOrderSuccess: function(model, response, options) {
                LEPersonalization.logger.info("widget model save success", "IFrameIntegrationWidgetOrganizeController:_widgetReOrderSuccess");

                LEPersonalization.loader.closeLoader();
            },
            _widgetReOrderError: function(model, response, options) {
                LEPersonalization.loader.closeLoader();
                LEPersonalization.logger.error("widget model save error", "IFrameIntegrationWidgetOrganizeController:_widgetReOrderSuccess", response);

                this._showGeneralSaveError();
            },
            _showGeneralSaveError: function(){
                LEPersonalization.notifier.showError({
                    content: LE.translator.translate("LEPersonalization.webAgent.widget.widgetOrganize.errors.default.save"),
                    timeToShow: 6000
                });
            }
        });
    });
    return IFrameIntegrationWidgetOrganizeController;
});
